import { render, staticRenderFns } from "./VendorHistory.vue?vue&type=template&id=432765b0&"
import script from "./VendorHistory.vue?vue&type=script&lang=js&"
export * from "./VendorHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports